import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVerificationStepConfig } from "@redux/selectors/verification-step-config-selectors";
import { initializeValidationResults } from "@redux/actions/validation-results-actions";
import { getInitialValidationResultsForCaptureStep } from "@utils/capture-step-validation-util";
import {
    getLivenessCheck,
    getUseAcuantSDKDPIValidation,
    getUseAcuantSDKGlareValidation,
    getUseAcuantSDKSharpnessValidation
} from "@redux/selectors/verification-configuration-selectors";
import { ValidationResults } from "@idw-types/data/validation-results";

export const useInitializeValidationResults = () => {
    const dispatch = useDispatch();
    const verificationStepConfig = useSelector(getVerificationStepConfig);
    const livenessCheck = useSelector(getLivenessCheck);
    const useAcuantSDKGlareValidation = useSelector(getUseAcuantSDKGlareValidation);
    const useAcuantSDKSharpnessValidation = useSelector(getUseAcuantSDKSharpnessValidation);
    const useAcuantSDKDPIValdidation = useSelector(getUseAcuantSDKDPIValidation);

    const initializeValidationResultsHelper = () => {
        const initialValidationResults: ValidationResults = {};
        verificationStepConfig.captureSteps.forEach(captureStep => {
            const initialCaptureStepValidationResults = getInitialValidationResultsForCaptureStep(
                captureStep.type,
                livenessCheck,
                useAcuantSDKDPIValdidation,
                useAcuantSDKGlareValidation,
                useAcuantSDKSharpnessValidation
            );
            initialValidationResults[captureStep.type] = initialCaptureStepValidationResults;
        });
        dispatch(initializeValidationResults(initialValidationResults));
    };

    useEffect(() => {
        if (verificationStepConfig.initialized) {
            initializeValidationResultsHelper();
        }
    }, [verificationStepConfig.initialized]);
};